import { APIConfiguration } from '@savgroup-front-common/configuration';

const SESSION_PROXY_PREFIX = '/api';

export const SESSION_REQUEST_HEADER_NAME = 'X-Requested-With';
export const SESSION_REQUEST_HEADER_VALUE = 'fetch';

let isSessionCookieModeEnabled = false;

export function enableSessionCookieMode(): void {
  isSessionCookieModeEnabled = true;
}

export function getIsSessionCookieModeEnabled(): boolean {
  return isSessionCookieModeEnabled;
}

export function toSameOriginApiUrl(url: string): string {
  const servicesBase = APIConfiguration.base.replace(/\/$/, '');

  if (!servicesBase || !url.startsWith(`${servicesBase}/`)) {
    return url;
  }

  return `${SESSION_PROXY_PREFIX}${url.slice(servicesBase.length)}`;
}

export function buildSessionRequestHeaders(
  url: string,
): Record<string, string> {
  if (!url.startsWith(`${SESSION_PROXY_PREFIX}/`)) {
    return {};
  }

  return { [SESSION_REQUEST_HEADER_NAME]: SESSION_REQUEST_HEADER_VALUE };
}

export function resetSessionCookieModeForTests(): void {
  if (!import.meta.env.DEV) {
    return;
  }

  isSessionCookieModeEnabled = false;
}
